/**
 * Canonical semantic accents for tenant-wide attendance metrics.
 *
 * The same meaning should travel across the compact header pill and the modal
 * drilldown so the user does not have to relearn the metric tone per surface.
 */
export const TENANT_ATTENDANCE_METRIC_ACCENT_COLOR = {
  available: 'success.main',
  attending: 'info.main',
  unavailable: 'warning.main',
  waiting: 'error.main',
} as const;

export const TENANT_ATTENDANCE_METRIC_INACTIVE_ICON_COLOR = 'rgba(255, 255, 255, 0.74)';
export const TENANT_ATTENDANCE_METRIC_INACTIVE_VALUE_COLOR = '#FFFFFF';

export type TenantAttendanceMetricKey = keyof typeof TENANT_ATTENDANCE_METRIC_ACCENT_COLOR;
